const reasons = [
  { title: "Customized Solutions", desc: "Tailored designs that reflect your unique taste and needs." },
  { title: "Skilled Craftsmanship", desc: "Expert workmanship ensuring durable and elegant finishes." },
  { title: "Comprehensive Services", desc: "Wide range covering all aspects of home improvement." },
]

const pillars = [
  { title: "Mission", desc: "To craft personalized, functional, and elegant living spaces with excellence." },
  { title: "Vision", desc: "To be India's leading choice for innovative and reliable interior design solutions." },
  { title: "Values", desc: "Creativity, Quality, Integrity, Customer Satisfaction, Innovation." },
]

export function WhyChooseUs() {
  return (
    <section className="border-t border-gray-200 py-20">
      <div className="mx-auto max-w-[1400px] px-8">
        {/* Quote banner */}
        <div className="reveal relative flex min-h-[320px] items-center justify-center overflow-hidden bg-gray-100">
          <img
            src="https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1200&q=80"
            alt="Interior design"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-navy/50" />
          <h3 className="relative font-heading text-2xl text-white italic sm:text-4xl md:text-5xl">
            &ldquo;EVERY ROOM NEEDS A TOUCH OF BLACK&rdquo;
          </h3>
        </div>

        {/* Why choose us cards */}
        <div className="mt-16 reveal">
          <div className="text-center">
            <p className="text-[11px] font-light tracking-[0.3em] text-gray-400 uppercase">
              Why Us
            </p>
            <h2 className="font-heading mt-3 text-[40px] leading-[1.15] text-navy sm:text-[48px]">
              WHY CHOOSE US
            </h2>
          </div>

          <div className="mt-12 grid gap-8 md:grid-cols-3">
            {reasons.map((r) => (
              <div key={r.title} className="border border-gray-200 p-8">
                <h4 className="font-heading text-xl text-navy uppercase">{r.title}</h4>
                <p className="mt-3 text-[14px] font-light leading-relaxed text-gray-500">
                  {r.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Mission / Vision / Values */}
        <div className="mt-16 reveal grid gap-16 md:grid-cols-2">
          <div>
            <h2 className="font-heading text-[36px] leading-[1.15] text-navy sm:text-[42px]">
              INTERIOR DESIGN
              <br />
              EXPERTS
            </h2>
            <p className="mt-4 text-[15px] font-light leading-relaxed text-gray-400">
              We specialize in creating functional, stylish homes tailored to your
              lifestyle, with diverse services from carpentry to civil works.
            </p>
          </div>
          <div className="space-y-6">
            {pillars.map((p) => (
              <div key={p.title} className="border-l-2 border-navy pl-6">
                <h4 className="font-heading text-lg text-navy uppercase">{p.title}</h4>
                <p className="mt-1 text-[13px] font-light leading-relaxed text-gray-400">
                  {p.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
